import { c as _c } from "react/compiler-runtime";
import { IcoChevronDown24, type Icon } from '@onefootprint/icons';
import * as RadixCollapsible from '@radix-ui/react-collapsible';
import { cx } from 'class-variance-authority';
import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
const {
  Root: CollapsibleRoot,
  Trigger: CollapsibleTrigger,
  Content: CollapsibleContent
} = RadixCollapsible;
type CollapsibleSectionProps = {
  icon: Icon;
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
};
const CollapsibleSection = t0 => {
  const $ = _c(31);
  const {
    icon: Icon,
    title,
    children,
    defaultOpen: t1
  } = t0;
  const defaultOpen = t1 === undefined ? false : t1;
  const [open, setOpen] = useState(defaultOpen);
  const [isHovered, setIsHovered] = useState(false);
  let t2;
  if ($[0] !== isHovered) {
    t2 = cx("flex flex-col rounded-md border border-tertiary w-full gap-1", {
      "bg-secondary": isHovered
    });
    $[0] = isHovered;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsHovered(true);
    t4 = () => setIsHovered(false);
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== Icon) {
    t5 = <Icon />;
    $[4] = Icon;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== title) {
    t6 = <p className="text-label-2 text-primary">{title}</p>;
    $[6] = title;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <div className="flex relative left-[-2px] gap-1 items-center justify-start">{t5}{t6}</div>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== open) {
    t8 = cx("flex transition-transform duration-200", {
      "-rotate-180": open
    });
    $[11] = open;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <IcoChevronDown24 />;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t8) {
    t10 = <div className={t8}>{t9}</div>;
    $[14] = t8;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t7) {
    t11 = <CollapsibleTrigger className="gap-1 p-3 flex items-center justify-between cursor-pointer rounded-md peer hover:bg-hover" onMouseEnter={t3} onMouseLeave={t4}>{t7}{t10}</CollapsibleTrigger>;
    $[16] = t10;
    $[17] = t7;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== children || $[20] !== open) {
    t12 = open && <CollapsibleContent forceMount={true} asChild={true}><motion.div className="pr-3 pb-3 pl-3" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }}>{children}</motion.div></CollapsibleContent>;
    $[19] = children;
    $[20] = open;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12) {
    t13 = <AnimatePresence>{t12}</AnimatePresence>;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t11 || $[25] !== t13 || $[26] !== t2) {
    t14 = <motion.div layoutRoot={true} className={t2}>{t11}{t13}</motion.div>;
    $[24] = t11;
    $[25] = t13;
    $[26] = t2;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== open || $[29] !== t14) {
    t15 = <div className="flex flex-col gap-2 items-start w-full"><CollapsibleRoot className="CollapsibleRoot" open={open} onOpenChange={setOpen} asChild={true}>{t14}</CollapsibleRoot></div>;
    $[28] = open;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  return t15;
};
export default CollapsibleSection;